import { memo } from "react";
import { ColumnElement, ColumnInput, DragItemIconSVG } from "./Modal.styles";

/**
 * Checkbox row for edit-columns / edit-summary-fields drawers.
 */
export const ColumnItem = memo(
  ({
    checked,
    disabled,
    draggable,
    header,
    id,
    index,
    onChange,
    onDragOver,
    onDragStart,
    onDrop,
  }) => {
    return (
      <ColumnElement
        draggable={!disabled && draggable}
        onDragStart={e => draggable && onDragStart(e, index)}
        onDragOver={draggable ? onDragOver : undefined}
        onDrop={draggable ? e => onDrop(e, index) : undefined}
      >
        {draggable && <DragItemIconSVG aria-hidden="true" />}
        <ColumnInput
          type="checkbox"
          value={id}
          checked={checked}
          onChange={onChange}
          aria-label={`${draggable ? "Reorder and toggle" : "Toggle"} column ${header}`}
        />
        {header}
      </ColumnElement>
    );
  },
);
